export const EVENTS_GET = "EVENTS_GET";
export const EVENTS_GET_SUCCESS = "EVENTS_GET_SUCCESS";
export const EVENTS_GET_FAILURE = "EVENTS_GET_FAILURE";
